export const races = [
  'Artrell',
  'Centaur',
  'Dwarf',
  'Elf',
  'Faerie',
  'Giant',
  'Gnoll',
  'Gnome',
  'Goblin',
  'Half-elf',
  'Half-ogre',
  'Half-orc',
  'Halfling',
  'Hobbit',
  'Human',
  'Imp',
  'Kender',
  'Kobold',
  'Nymph',
  'Ogre',
  'Ogre-magi',
  'Orc',
  'Satyr',
  'Troll',
  'Dragon',
  'Drow-elf',
  'Lich',
];

// Structured as raceStats[Race][Stat] = tier (1-5).
// Any stat not listed for a race falls back to RACE_DEFAULT (tier 4) in getRaceRank.
// Transcribed directly from the developer-provided race_stats mapping.
export const raceStats = {
  Artrell: { Charisma: 5, Dexterity: 1, Wisdom: 2 },
  Centaur: { Strength: 2, Constitution: 1, Dexterity: 2, Intelligence: 5, Wisdom: 5 },
  Dragon: { Strength: 1, Charisma: 1, Constitution: 1, Dexterity: 1, Intelligence: 1, Wisdom: 1 },
  'Drow-elf': { Strength: 2, Charisma: 5, Dexterity: 2, Intelligence: 2, Wisdom: 2 },
  Dwarf: { Strength: 2, Wisdom: 1 },
  Elf: { Intelligence: 1, Wisdom: 2 },
  Faerie: { Strength: 5, Charisma: 2, Constitution: 5, Dexterity: 2, Intelligence: 2, Wisdom: 2 },
  Giant: { Strength: 1, Charisma: 5, Constitution: 2, Wisdom: 2 },
  Gnoll: { Strength: 2, Constitution: 2 },
  Gnome: { Charisma: 5, Intelligence: 1, Wisdom: 2 },
  Goblin: { Strength: 2, Dexterity: 2 },
  'Half-elf': { Charisma: 2, Dexterity: 2 },
  'Half-ogre': { Strength: 2, Intelligence: 2 },
  'Half-orc': { Constitution: 2, Dexterity: 2 },
  Halfling: { Charisma: 2, Constitution: 5, Dexterity: 1, Intelligence: 2, Wisdom: 2 },
  Hobbit: { Charisma: 2, Dexterity: 1, Intelligence: 5 },
  Human: { Charisma: 1, Wisdom: 2 },
  Imp: { Strength: 5, Constitution: 5, Dexterity: 2, Intelligence: 1, Wisdom: 1 },
  Kender: { Constitution: 1, Dexterity: 2, Intelligence: 2, Wisdom: 5 },
  Kobold: { Strength: 2, Constitution: 2, Dexterity: 2 },
  Lich: { Intelligence: 1, Wisdom: 1 },
  Nymph: { Strength: 5, Charisma: 1, Constitution: 5, Dexterity: 2, Wisdom: 1 },
  Ogre: { Strength: 2, Charisma: 5, Constitution: 1 },
  'Ogre-magi': { Strength: 2, Charisma: 5, Constitution: 2, Dexterity: 4, Intelligence: 2, Wisdom: 2 },
  Orc: { Strength: 2, Constitution: 2 },
  Satyr: { Strength: 1, Charisma: 5, Dexterity: 2 },
  Troll: { Strength: 1, Charisma: 5, Constitution: 2 },
  'Were-wolf': { Strength: 1, Dexterity: 2 },
};

// Structured as classStats[Class][Stat] = tier (1-5).
// Any stat not listed for a class falls back to CLASS_DEFAULT (tier 5) in getClassRank.
// Transcribed directly from the developer-provided class_stats mapping.
export const classStats = {
  Cleric: { Strength: 2, Charisma: 2, Constitution: 4, Intelligence: 1, Wisdom: 2 },
  Dragon: { Strength: 4, Charisma: 4, Constitution: 4, Dexterity: 4, Intelligence: 4, Wisdom: 4 },
  Fighter: { Strength: 1, Constitution: 1, Dexterity: 2 },
  Mage: { Charisma: 2, Dexterity: 4, Intelligence: 1, Wisdom: 1 },
  Monk: { Strength: 2, Charisma: 3, Constitution: 2, Dexterity: 2, Intelligence: 2, Wisdom: 2 },
  Rogue: { Strength: 2, Charisma: 1, Constitution: 3, Dexterity: 1 },
};

export const raceCfg = {
  Artrell: {
    sight: 2,
    weight: 5800,
    fingers: 2,
    wielding: 4,
    str: -5,
    con: -9,
    int: -2,
    wis: -2,
    dex: 6,
    cha: -6,
  },
  Centaur: {
    sight: 0,
    weight: 13000,
    fingers: 5,
    wielding: 2,
    str: 5,
    con: 6,
    int: -4,
    wis: -4,
    dex: 3,
    cha: -5,
  },
  Dragon: {
    sight: 2,
    weight: 19999,
    fingers: 3,
    wielding: 0,
    str: 9,
    con: 9,
    int: 9,
    wis: 9,
    dex: 9,
    cha: 9,
  },
  'Drow-elf': {
    sight: 4,
    weight: 7000,
    fingers: 5,
    wielding: 2,
    str: -2,
    con: 0,
    int: 7,
    wis: 8,
    dex: 2,
    cha: 2,
  },
  Dwarf: {
    sight: 1,
    weight: 6000,
    fingers: 4,
    wielding: 2,
    str: 2,
    con: 4,
    int: -1,
    wis: 4,
    dex: 3,
    cha: -4,
  },
  Elf: {
    sight: 3,
    weight: 10001,
    fingers: 5,
    wielding: 2,
    str: 0,
    con: 0,
    int: 5,
    wis: 8,
    dex: 3,
    cha: 1,
  },
  Faerie: {
    sight: -1,
    weight: 5001,
    fingers: 5,
    wielding: 2,
    str: -9,
    con: -9,
    int: 8,
    wis: 9,
    dex: 9,
    cha: 5,
  },
  Giant: {
    sight: -1,
    weight: 14999,
    fingers: 6,
    wielding: 2,
    str: 9,
    con: 9,
    int: -4,
    wis: -9,
    dex: -6,
    cha: -2,
  },
  Gnoll: {
    sight: 1,
    weight: 8500,
    fingers: 5,
    wielding: 2,
    str: 2,
    con: 9,
    int: 0,
    wis: 0,
    dex: 1,
    cha: 1,
  },
  Gnome: {
    sight: 2,
    weight: 8000,
    fingers: 4,
    wielding: 2,
    str: -1,
    con: -1,
    int: 5,
    wis: 5,
    dex: 1,
    cha: -7,
  },
  Goblin: {
    sight: 1,
    weight: 8000,
    fingers: 5,
    wielding: 2,
    str: 7,
    con: 6,
    int: -1,
    wis: -1,
    dex: 5,
    cha: -9,
  },
  Halfling: {
    sight: 3,
    weight: 7000,
    fingers: 5,
    wielding: 2,
    str: -2,
    con: -3,
    int: -1,
    wis: 0,
    dex: 9,
    cha: -4,
  },
  'Half-elf': {
    sight: 2,
    weight: 7500,
    fingers: 4,
    wielding: 2,
    str: 0,
    con: -2,
    int: -2,
    wis: -5,
    dex: 4,
    cha: 2,
  },
  'Half-ogre': {
    sight: 1,
    weight: 10500,
    fingers: 6,
    wielding: 2,
    str: 6,
    con: 8,
    int: -5,
    wis: -8,
    dex: 3,
    cha: -5,
  },
  'Half-orc': {
    sight: 2,
    weight: 9000,
    fingers: 4,
    wielding: 2,
    str: 5,
    con: 6,
    int: -1,
    wis: -3,
    dex: 1,
    cha: -6,
  },
  Hobbit: {
    sight: 1,
    weight: 4500,
    fingers: 4,
    wielding: 2,
    str: -1,
    con: -3,
    int: -2,
    wis: -4,
    dex: 8,
    cha: 1,
  },
  Human: {
    sight: 0,
    weight: 9999,
    fingers: 5,
    wielding: 2,
    str: -1,
    con: -1,
    int: 1,
    wis: 0,
    dex: 0,
    cha: 3,
  },
  Imp: {
    sight: 1,
    weight: 6001,
    fingers: 5,
    wielding: 2,
    str: -7,
    con: -7,
    int: 9,
    wis: 9,
    dex: 9,
    cha: 0,
  },
  Kender: {
    sight: 0,
    weight: 4999,
    fingers: 5,
    wielding: 2,
    str: -5,
    con: 5,
    int: 4,
    wis: -8,
    dex: 7,
    cha: 4,
  },
  Kobold: {
    sight: 2,
    weight: 9500,
    fingers: 5,
    wielding: 2,
    str: 3,
    con: 3,
    int: 1,
    wis: 1,
    dex: 3,
    cha: 0,
  },
  Lich: {
    sight: 4,
    weight: 8000,
    fingers: 5,
    wielding: 2,
    str: 0,
    con: 8,
    int: 9,
    wis: 9,
    dex: 0,
    cha: -9,
  },
  Nymph: {
    sight: 0,
    weight: 8500,
    fingers: 5,
    wielding: 2,
    str: -4,
    con: -1,
    int: -5,
    wis: -9,
    dex: 8,
    cha: 9,
  },
  Ogre: {
    sight: 0,
    weight: 11000,
    fingers: 6,
    wielding: 2,
    str: 7,
    con: 9,
    int: -6,
    wis: -9,
    dex: 2,
    cha: -9,
  },
  'Ogre-magi': {
    sight: 1,
    weight: 11500,
    fingers: 6,
    wielding: 2,
    str: 7,
    con: 8,
    int: 6,
    wis: 6,
    dex: 2,
    cha: -7,
  },
  Orc: {
    sight: 1,
    weight: 11500,
    fingers: 6,
    wielding: 2,
    str: 7,
    con: 9,
    int: -5,
    wis: -9,
    dex: -1,
    cha: -7,
  },
  Satyr: {
    sight: 0,
    weight: 10050,
    fingers: 4,
    wielding: 2,
    str: 6,
    con: 6,
    int: -7,
    wis: -5,
    dex: 2,
    cha: -8,
  },
  Troll: {
    sight: 2,
    weight: 9000,
    fingers: 5,
    wielding: 2,
    str: 4,
    con: 3,
    int: 0,
    wis: 0,
    dex: 0,
    cha: -3,
  },
  'Were-wolf': {
    sight: 3,
    weight: 14000,
    fingers: 5,
    wielding: 0,
    str: 9,
    con: 9,
    int: -5,
    wis: -5,
    dex: 9,
    cha: -5,
  },
};
